module.exports = __webpack_public_path__ + "img/fondation_sante_gatineau.7c26f138.webp";